import css from "./UserLink.module.css";

import { Link } from "react-router";
import { Icon16 } from "../ui/Icon";

export type UserLinkData = {
  id: number | null;
  avatar?: string | null;
  name: string | null;
};

export function UserLink(props: { user: UserLinkData }) {
  return (
    <Link to={`/users/${props.user.id}`} className={css.userLink}>
      <span className={css.icon}>
        <Icon16 icon={props.user.avatar || "skill4293"} />
      </span>
      <span className={css.name}>{props.user.name}</span>
    </Link>
  );
}
